/* eslint-disable bsky-internal/avoid-unwrapped-text */
import './LoginForm.css'

import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'
import {Trans} from '@lingui/react/macro'
import type React from 'react'
import {useController} from 'react-hook-form'

import {type PasswordResetFormData} from '#/lib/schemas/password-reset'
import {TOKENS} from '#/wsocial/service/design-system/tokens'
import logoSvg from '../../../assets/icon-wsocial.svg'
import {type PasswordResetForm} from './types'

const T = {
  bg: TOKENS.dark.custom_background_primary,
  inputBg: '#272F44',
  textMedium: '#D0CFD7',
  accent: TOKENS.dark.positive_700,
  btnText: TOKENS.dark.custom_text_light,
  borderLow: TOKENS.dark.custom_border_contrast_low,
  negative: TOKENS.dark.negative_500,
} as const

const inputStyle: React.CSSProperties = {
  flex: 1,
  background: 'transparent',
  border: 'none',
  outline: 'none',
  fontSize: 15,
  fontWeight: 400,
  color: '#fff',
  lineHeight: '23px',
  minWidth: 0,
}

const inputRowStyle: React.CSSProperties = {
  backgroundColor: T.inputBg,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  height: 44,
  padding: '0 12px',
  borderRadius: 10,
}

const labelStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 500,
  lineHeight: '17px',
  color: T.textMedium,
  display: 'block',
  margin: 0,
}

function CodeIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 12"
      fill="none"
      style={{flexShrink: 0}}>
      <path
        fill={T.accent}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 0C0.551088 0 0.360323 0.0790178 0.21967 0.21967C0.079018 0.360322 4.31961e-07 0.551088 4.31961e-07 0.75V3.8775C-0.000166177 4.03278 0.0478675 4.18428 0.137472 4.3111C0.227077 4.43791 0.353834 4.53379 0.50025 4.5855C0.792559 4.68912 1.04559 4.88076 1.22453 5.13406C1.40348 5.38735 1.49956 5.68987 1.49956 6C1.49956 6.31013 1.40348 6.61265 1.22453 6.86594C1.04559 7.11924 0.792559 7.31088 0.50025 7.4145C0.353834 7.46621 0.227077 7.56209 0.137472 7.6889C0.0478675 7.81572 -0.000166177 7.96722 4.31961e-07 8.1225V11.25C4.31961e-07 11.4489 0.079018 11.6397 0.21967 11.7803C0.360323 11.921 0.551088 12 0.75 12H14.25C14.4489 12 14.6397 11.921 14.7803 11.7803C14.921 11.6397 15 11.4489 15 11.25V8.1225C15.0002 7.96722 14.9521 7.81572 14.8625 7.6889C14.7729 7.56209 14.6462 7.46621 14.4998 7.4145C14.2074 7.31088 13.9544 7.11924 13.7755 6.86594C13.5965 6.61265 13.5004 6.31013 13.5004 6C13.5004 5.68987 13.5965 5.38735 13.7755 5.13406C13.9544 4.88076 14.2074 4.68912 14.4998 4.5855C14.6462 4.53379 14.7729 4.43791 14.8625 4.3111C14.9521 4.18428 15.0002 4.03278 15 3.8775V0.75C15 0.551088 14.921 0.360322 14.7803 0.21967C14.6397 0.0790178 14.4489 0 14.25 0H0.75ZM1.5 3.40125V1.5H13.5V3.40125C13.0438 3.66461 12.6651 4.04343 12.4018 4.49962C12.1384 4.9558 11.9999 5.47328 12 6C12 7.1115 12.6037 8.07975 13.5 8.59875V10.5H1.5V8.59875C1.95616 8.33539 2.33493 7.95657 2.59825 7.50038C2.86156 7.0442 3.00012 6.52672 3 6C3.00012 5.47328 2.86156 4.9558 2.59825 4.49962C2.33493 4.04343 1.95616 3.66461 1.5 3.40125ZM9.75 8.25C9.55109 8.25 9.36032 8.32902 9.21967 8.46967C9.07902 8.61032 9 8.80109 9 9C9 9.19891 9.07902 9.38968 9.21967 9.53033C9.36032 9.67098 9.55109 9.75 9.75 9.75C9.94891 9.75 10.1397 9.67098 10.2803 9.53033C10.421 9.38968 10.5 9.19891 10.5 9C10.5 8.80109 10.421 8.61032 10.2803 8.46967C10.1397 8.32902 9.94891 8.25 9.75 8.25ZM9 6C9 5.80109 9.07902 5.61032 9.21967 5.46967C9.36032 5.32902 9.55109 5.25 9.75 5.25C9.94891 5.25 10.1397 5.32902 10.2803 5.46967C10.421 5.61032 10.5 5.80109 10.5 6C10.5 6.19891 10.421 6.38968 10.2803 6.53033C10.1397 6.67098 9.94891 6.75 9.75 6.75C9.55109 6.75 9.36032 6.67098 9.21967 6.53033C9.07902 6.38968 9 6.19891 9 6ZM9.75 2.25C9.55109 2.25 9.36032 2.32902 9.21967 2.46967C9.07902 2.61032 9 2.80109 9 3C9 3.19891 9.07902 3.38968 9.21967 3.53033C9.36032 3.67098 9.55109 3.75 9.75 3.75C9.94891 3.75 10.1397 3.67098 10.2803 3.53033C10.421 3.38968 10.5 3.19891 10.5 3C10.5 2.80109 10.421 2.61032 10.2803 2.46967C10.1397 2.32902 9.94891 2.25 9.75 2.25Z"
      />
    </svg>
  )
}

function LockIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      style={{flexShrink: 0}}>
      <path
        fill={T.accent}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 7a5 5 0 0 1 10 0v2h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h1V7Zm-1 4v9h12v-9H6Zm9-2H9V7a3 3 0 1 1 6 0v2Zm-3 4a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
      />
    </svg>
  )
}

export function StepNewPassword({
  form,
  error,
  isProcessing,
  email,
  onBack,
  onSubmit,
}: {
  form: PasswordResetForm
  error: string
  isProcessing: boolean
  email: string
  onBack: () => void
  onSubmit: () => void
}) {
  const {_} = useLingui()
  const {field: tokenField, fieldState: tokenState} = useController<
    PasswordResetFormData,
    'token'
  >({
    control: form.control,
    name: 'token',
  })
  const {field: passwordField, fieldState: passwordState} = useController<
    PasswordResetFormData,
    'password'
  >({
    control: form.control,
    name: 'password',
  })

  const canContinue =
    tokenField.value.trim().length > 0 && passwordField.value.length >= 8

  const handleSubmit = async () => {
    const isValid = await form.trigger(['token', 'password'])
    if (isValid) onSubmit()
  }

  return (
    <div
      className="LoginPageShell"
      style={{
        backgroundColor: T.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: '100vh',
      }}>
      <div
        className="LoginPageShellInner"
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '100%',
        }}>
        {/* Logo */}
        <div
          className="LoginLogoBlock"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <img src={logoSvg} alt="W Social" style={{width: 80, height: 80}} />
        </div>

        {/* Heading */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            padding: '0 16px',
          }}>
          <h1
            style={{
              fontSize: 30,
              fontWeight: 700,
              lineHeight: '35px',
              color: '#fff',
              margin: 0,
            }}>
            <Trans>New password</Trans>
          </h1>
          <p
            style={{
              fontSize: 13,
              fontWeight: 400,
              lineHeight: '17px',
              color: T.textMedium,
              margin: 0,
            }}>
            {email ? (
              <Trans>
                A reset code was sent to {email}. Enter it below along with your
                new password.
              </Trans>
            ) : (
              <Trans>
                Enter the reset code you received by email along with your new
                password.
              </Trans>
            )}
          </p>
        </div>

        {/* Form */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: '24px 16px',
          }}>
          <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
            <label style={labelStyle}>
              <Trans>Reset code</Trans>
            </label>
            <div style={inputRowStyle}>
              <CodeIcon />
              <input
                type="text"
                placeholder={_(msg`Looks like XXXXX-XXXXX`)}
                value={tokenField.value}
                onChange={e => tokenField.onChange(e.target.value)}
                onBlur={tokenField.onBlur}
                disabled={isProcessing}
                autoComplete="one-time-code"
                className="SignInInput"
                style={inputStyle}
                autoFocus
              />
            </div>
            {tokenState.error?.message && (
              <p
                style={{
                  color: T.negative,
                  fontSize: 13,
                  lineHeight: '17px',
                  margin: 0,
                  padding: '8px 0',
                }}>
                {tokenState.error.message}
              </p>
            )}
          </div>

          <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
            <label style={labelStyle}>
              <Trans>New password</Trans>
            </label>
            <div style={inputRowStyle}>
              <LockIcon />
              <input
                type="password"
                placeholder={_(msg`Enter a password`)}
                value={passwordField.value}
                onChange={e => passwordField.onChange(e.target.value)}
                onBlur={passwordField.onBlur}
                onKeyDown={e =>
                  e.key === 'Enter' && canContinue && handleSubmit()
                }
                disabled={isProcessing}
                autoComplete="new-password"
                className="SignInInput"
                style={inputStyle}
              />
            </div>
            {(passwordState.error?.message || error) && (
              <p
                style={{
                  color: T.negative,
                  fontSize: 13,
                  lineHeight: '17px',
                  margin: 0,
                  padding: '8px 0',
                }}>
                {passwordState.error?.message || error}
              </p>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div
          style={{
            padding: '0 16px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <button
            onClick={onBack}
            disabled={isProcessing}
            className="BackButton">
            <Trans>Back</Trans>
          </button>
          <button
            onClick={handleSubmit}
            disabled={!canContinue || isProcessing}
            className="SignInContinueBtn"
            style={{
              backgroundColor: T.accent,
              color: T.btnText,
              fontSize: 15,
              fontWeight: 500,
              lineHeight: '20px',
              padding: '0 25px',
              height: 44,
              borderRadius: 8,
              border: 'none',
              cursor: canContinue && !isProcessing ? 'pointer' : 'not-allowed',
              opacity: canContinue && !isProcessing ? 1 : 0.6,
              whiteSpace: 'nowrap',
            }}>
            {isProcessing ? '...' : <Trans>Update password</Trans>}
          </button>
        </div>

        {/* Support footer */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            padding: '16px 16px',
          }}>
          <div
            style={{height: 1, backgroundColor: T.borderLow, width: '100%'}}
          />
          <p
            style={{
              fontSize: 13,
              fontWeight: 400,
              lineHeight: '17px',
              color: T.textMedium,
              margin: 0,
            }}>
            <Trans>Having trouble?</Trans>{' '}
            <a href="mailto:support@wsocial.eu" className="LinkNew">
              <Trans>Contact support</Trans>
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
